<div *ngIf="album.length > 0">
	<cv-gallery [isEditable]="isEditable" [album]="album" [options]="galleryOptions"></cv-gallery>
</div>

<div class="container-no-files" *ngIf="album.length <= 0">
	<img src="assets/img/placeholder/No-file-asset.png">
	<p>No files available</p>
</div>